import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

export const selectLookups = createSelector(
  (state: RootState) => state.lookups.lookups,
  (state: RootState) => state.lookups.total,
  (state: RootState) => state.lookups.loadingLookups,
  (lookups, total, loadingLookups) => ({
    lookups,
    total,
    loadingLookups,
  }),
);
